export default __webpack_public_path__ + "static/media/opensans-semibolditalic-webfont.8ca7114c.woff2";